module.exports = __webpack_public_path__ + "img/1546544432.5c1c9e99.jpg";